var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.2549 80.719C27.2549 88.049 21.2769 94.036 13.9459 94.036C6.61488 94.036 0.629883 88.049 0.629883 80.719C0.629883 73.389 6.61688 67.402 13.9469 67.402H27.2559L27.2549 80.719ZM33.9639 80.719C33.9639 73.389 39.9509 67.402 47.2809 67.402C54.6109 67.402 60.5979 73.388 60.5979 80.719V114.054C60.5979 121.384 54.6119 127.371 47.2809 127.371C39.9509 127.371 33.9639 121.384 33.9639 114.054V80.719Z",
    fill: "#DE1C59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2809 27.255C39.9509 27.255 33.9639 21.277 33.9639 13.946C33.9639 6.61501 39.9509 0.630005 47.2809 0.630005C54.6109 0.630005 60.5979 6.617 60.5979 13.947V27.256L47.2809 27.255ZM47.2809 33.964C54.6109 33.964 60.5979 39.951 60.5979 47.281C60.5979 54.611 54.6119 60.598 47.2809 60.598H13.9459C6.61588 60.598 0.629883 54.612 0.629883 47.281C0.629883 39.951 6.61688 33.964 13.9469 33.964H47.2809Z",
    fill: "#35C5F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.745 47.281C100.745 39.951 106.723 33.964 114.054 33.964C121.385 33.964 127.371 39.951 127.371 47.281C127.371 54.611 121.384 60.598 114.054 60.598H100.745V47.281ZM94.0363 47.281C94.0363 54.611 88.0493 60.598 80.7193 60.598C73.3893 60.598 67.4023 54.612 67.4023 47.281V13.946C67.4023 6.616 73.3883 0.630005 80.7193 0.630005C88.0493 0.630005 94.0363 6.617 94.0363 13.947V47.281Z",
    fill: "#2EB57D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7193 100.745C88.0493 100.745 94.0363 106.723 94.0363 114.054C94.0363 121.385 88.0493 127.371 80.7193 127.371C73.3893 127.371 67.4023 121.384 67.4023 114.054V100.745H80.7193ZM80.7193 94.036C73.3893 94.036 67.4023 88.049 67.4023 80.719C67.4023 73.389 73.3883 67.402 80.7193 67.402H114.054C121.384 67.402 127.371 73.388 127.371 80.719C127.371 88.049 121.384 94.036 114.054 94.036H80.7193Z",
    fill: "#EBB02E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlack);
export default __webpack_public_path__ + "static/media/slack.631ee6f82e8446553410600715020c5b.svg";
export { ForwardRef as ReactComponent };